import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EventLoggerService } from '@services/event-logger-service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-gamification-reward-banner',
  imports: [],
  templateUrl: './gamification-reward-banner.component.html',
})
export class GamificationRewardBannerComponent {
  @Input() rewardData: { objectId: string; amount?: number; expireAt?: { iso?: string } } | null = null;
  @Input() isClaimed: boolean = false;
  @Output() openScratchCard = new EventEmitter<void>();

  constructor(
    private readonly eventLogger: EventLoggerService,
    private readonly router: Router,) {}

  onBannerClick(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'skinStart_reward_strip_banner' }));
    if (!this.isClaimed) {
      this.openScratchCard.emit();
    } else {
      this.router.navigate(['/user/wallet']);
    }
  }
}
